import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource, MatSort,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { DataSource } from '@angular/cdk/collections';
import { TripService } from '../../services/trip/trip.service';
import { AllorderdetailsComponent } from '../order/allorderdetails/allorderdetails.component'
import { PdfgeneratorService } from '../../services/pdfgenerator/pdfgenerator.service';
import { ExcelgeneratorService } from '../../services/excelgenerator/excelgenerator.service';
import html2canvas from 'html2canvas';
import { NgxDateRangePickerOptions } from 'src/ngx-daterangepicker';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TripdetailsComponent } from '../trip/tripdetails/tripdetails.component';
import { TokenStorage } from 'src/app/auth/token.storage';

@Component({
  selector: 'app-diagnostic-summary-report',
  templateUrl: './diagnostic-summary-report.component.html',
  styleUrls: ['./diagnostic-summary-report.component.scss']
})
export class DiagnosticSummaryReportComponent implements OnInit {
  columnsToDisplay = [
    'fullName',
    'phoneNumber',
    'roleName',
    'totalKms',
    'totalSamplePickups',
    'totalTrips',
    'totalVisited',
  ];
  summaryDataArray = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  options: NgxDateRangePickerOptions;
  page: number = 0;
  totalRecords: Number;
  excelRecords = [];
  selected = '7';
  dateRangevalue: any = { to: "", from: "" };
  fromDate: any;
  toDate: any;
  isDateFiltered: boolean = false;
  trips = [];
  isLoading: boolean = false;
  prevFromDate: any;
  prevTodate: any;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public dialog: MatDialog,
    public tripService: TripService,
    public generatePdf: PdfgeneratorService,
    public excelService: ExcelgeneratorService,
    public datePipe: DatePipe,
    public decimalPipe: DecimalPipe,
    private token: TokenStorage
  ) {
  }

  ngOnInit() {
    this.createInitialFilter();
    this.tripFilter();
  }

  dataForExcel() {
    let summaryDataArray = [];
    if (this.summaryDataArray.filteredData)
      summaryDataArray = this.summaryDataArray.filteredData;
    else
      summaryDataArray = this.summaryDataArray.data;
    this.excelRecords = [];
    summaryDataArray.forEach(trip => {
      if (trip) {
        this.excelRecords.push({
          'Name': trip.fullName || '',
          'Phone No.': trip.phoneNumber || '',
          'Department ': trip.roleName || '',
          'Kms': Number(trip.totalKms).toFixed(2) || '',
          'Sample Pickups': trip.totalSamplePickups || '',
          'Trips': trip.totalTrips || '',
          'Visited': trip.totalVisited || '',
        });
      }
    });
  }

  public captureScreen() {
    var data = document.getElementById('contentToConvert');
    html2canvas(data).then(canvas => {
      this.generatePdf.pdfgenerator(canvas, this.summaryDataArray.data.length);
    });
  }

  exportAsXLSX(): void {
    this.dataForExcel();
    this.excelService.exportAsExcelFile(this.excelRecords, 'summaryReport');
  }

  ngAfterViewInit() {
    this.summaryDataArray.paginator = this.paginator;
  }
  createInitialFilter() {
    this.options = {
      theme: 'default',
      labels: ['Start', 'End'],
      menu: null,
      dateFormat: 'YYYY-MM-DD',
      outputFormat: 'DD-MM-YYYY',
      startOfWeek: 1,
      outputType: 'object',
      locale: 'en',
      date: {
        from: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        },
        to: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        }
      }
    };
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.dateRangevalue.from = this.datePipe.transform(new Date(), 'dd-MM-yyyy');
    this.dateRangevalue.to = this.datePipe.transform(new Date(), 'dd-MM-yyyy');
    this.prevFromDate = this.fromDate;
    this.prevTodate = this.toDate;
    this.isDateFiltered = true;
  }

  tripFilter() {
    this.isLoading = true;
    this.summaryDataArray.data = [];
    this.getData(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(trips => {
      console.log("Trips in report", trips);
      this.isLoading = false;
      this.summaryDataArray.data = trips;
    }, Error=>{
      this.isLoading = false;
    })
  }

  getData(from, to) {
    return this.tripService.getsummaryReport(from, to);
  }

  sortByDate() {
    if (!this.dateRangevalue) {
      this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.tripFilter();
      this.prevFromDate = this.fromDate;
      this.prevTodate = this.toDate;
    }

    else if (this.dateRangevalue) {
      this.fromDate = this.dateRangevalue.from.substring(6, 10) + '-' + this.dateRangevalue.from.substring(3, 5) + '-' + this.dateRangevalue.from.substring(0, 2);
      this.toDate = this.dateRangevalue.to.substring(6, 10) + '-' + this.dateRangevalue.to.substring(3, 5) + '-' + this.dateRangevalue.to.substring(0, 2);
      if (this.toDate != this.prevTodate || this.fromDate != this.prevFromDate) {
        this.isDateFiltered = true;
        this.ngUnsubscribe.next();
        this.tripFilter();
        this.prevFromDate = this.fromDate;
        this.prevTodate = this.toDate;
      }
    }
  }

  clearAllFilter() {
    this.paginator.pageIndex = 0;
    this.createInitialFilter();
    this.isDateFiltered = false;
  }
}

